

// 5 JUN 2026
import React, { useEffect, useMemo, useState } from "react";

// import "./SCADAWTPRTP.css";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "./scadawtp.css";
import { HmacSHA256 } from "crypto-js";
import { Heading6 } from "lucide-react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// =====================================================
// TRANSFORM API DATA
// =====================================================

export function transformScadaWtpData(apiResponse) {

  const apiData = apiResponse?.data || [];

  if (!Array.isArray(apiData)) return [];

  return apiData.flatMap((item) => {

    const intake = item?.intake;
    const wtpUnits = item?.wtpUnits || [];

    return wtpUnits.flatMap((unit) => {

      const wtpName =
        unit?.wtp?.wtP_Name ||
        "wtp_unknown";

      const intakeWell =
        intake?.intakeWellName ||
        "intake_unknown";

      const ohts = unit?.ohts || [];

      return ohts.map((oht, index) => ({

        intakewell: intakeWell,

        wtp: wtpName,

        oht:
          oht?.ohT_Name ||
          `oht_${index + 1}`

      }));
    });
  });
}

// =====================================================
// ICONS
// =====================================================

const ICONS = {

  intake: (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M4 19h16M6 17V9l6-4 6 4v8"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 17v-5h6v5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  ),

  wtp: (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M4 19h16M6 19V8l5 3V8l5 3V7h2v12"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 15h2M13 15h2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  ),

  oht: (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M7 7h10v5a5 5 0 0 1-10 0V7Z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M5 7h14M8 21l2-5M16 21l-2-5M10 21h4"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  )
};


// =====================================================
// HELPERS
// =====================================================

function random(min, max) {

  return Math.floor(
    Math.random() * (max - min + 1)
  ) + min;
}

function unique(rows, key) {

  return [
    ...new Set(rows.map((row) => row[key]))
  ];
}

function groupData(rows) {

  const grouped = {};

  rows.forEach((row) => {

    grouped[row.intakewell] ||= {};

    grouped[row.intakewell][row.wtp] ||= [];

    grouped[row.intakewell][row.wtp].push(
      row.oht
    );
  });

  return grouped;
}

function nodeFlow(type) {

  return random(
    type === "oht" ? 55 : 120,
    type === "oht" ? 260 : 440
  );
}
//27MAY  CODE MAIN FUNCTION
export default function SCADAWTP() {

  const [departmentFilter, setDepartmentFilter] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });


  const navigate = useNavigate();
  // 29MAY CODE FOR DATA SET 
  const [DATA, setDATA] = useState([]);
  // const [tableData, setTableData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [clock, setClock] = useState("--:--:--");
  const [apiResponse, setapiResponse] = useState({});
  const [nodes, setNodes] = useState([]);
  const [cards, setCards] = useState([]);
  const [telemetry, setTelemetry] = useState({
    intakeCount: 0,
    wtpCount: 0,
    ohtCount: 0,
    flowValue: 0,
    pipeCount: 0
  });

  // CODE FOR DATA SET


  const {currentStageValue, isSideBar } = useSelector((state) => state.currentStage);
  const [isScreenSize1, setIsScreenSize1] = useState(window.innerWidth <= 991);
  const dispatch = useDispatch();
  const authData = useSelector(state => state.authToken.authData);
  // BHUPEN_ULB
  const [showPopup, setShowPopup] = useState(false);
  const [tableDataALL, setTableDataALL] = useState([]);
  const [tblResults, settblResults] = useState([]);
  const [tableDataINTEK, setTableDataINTEK] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableVisible, setTableVisible] = useState(true);
  const [tableMaximize, setTableMaximize] = useState(false);
  //Maximized
  const [isMapPanelMaximized, setIsMapPanelMaximized] = useState(false);
  const [isTableMaximized, setIsTableMaximized] = useState(false);


  const [distictList, setdistictList] = React.useState([]);

  const [directorFilter, setDirectorFilter] = useState("");
  const [searchText, setSearchText] = useState("");



  // 
  // CARD CREATE
  // RTPCARDS
  const [RTPcards, setRTPCards] = useState({
    schemes: 0,
    ulb: 0,
    intake: 0,
    wtp: 0,
    oht: 0
  });

  const API =
    "https://urbangis.mp.gov.in/api/Station_Data/GetScadaWTPDataNEW";


  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    try {
      let res = await fetch(API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          intakeID: null,
          distCd: null,
          ulbCd: null
        })
      });
      let json = await res.json();
      // generateReport(json.data);
      generateCards(json.data);

    }
    catch (err) {

      console.log(err);

    }


  };


  // CODE FOR  Header DATA 


  const generateCards = (data) => {
    let schemeSet = new Set();
    let ulbSet = new Set();
    let intake = 0;
    let wtp = 0;
    let oht = 0;
    data.forEach(item => {
      // Scheme
      if (item.intake?.schemeName) {
        schemeSet.add(
          item.intake.schemeName
        );
      }
      // Intake
      intake++;
      // ULB
      if (item.intake?.ulb_Code) {
        ulbSet.add(
          item.intake.ulb_Code
        );
      }
      item.wtpUnits?.forEach(unit => {
        wtp++;
        oht += unit.ohts?.length || 0;
      });
    });
    setRTPCards({
      schemes: schemeSet.size,
      ulb: ulbSet.size,
      intake: intake,
      wtp: wtp,
      oht: oht
    });
  };

  // CARD CREATE


  const [isScadaFullscreen, setIsScadaFullscreen] = useState(false);






  // =====================================================
  // CLOCK
  // =====================================================

  useEffect(() => {

    const tick = () => {

      setClock(
        new Date().toLocaleTimeString()
      );
    };

    tick();

    const id = setInterval(tick, 1000);

    return () => clearInterval(id);

  }, []);

  const [activeType, setActiveType] = useState("intake");
  // 25 JUN 2026
  useEffect(() => {
    try {
      if (!apiResponse?.data) return;

      const apiData = Array.isArray(apiResponse.data)
        ? apiResponse.data
        : [];

      //  console.log("TEST DATA 26 JUN 2026 ");
      // console.log(apiData);

      let activeFilter = selectedFilter;

      if (!activeFilter && apiData.length > 0) {
        activeFilter = apiData[0]?.intake?.schemeName;
        setSelectedFilter(activeFilter);
      }

      const filteredApiData =
        activeFilter === "all"
          ? apiData
          : apiData.filter(
            (item) =>
              item?.intake?.schemeName === activeFilter
          );

      let typeList = [];

      // ✅ INTAKE
      if (activeType === "intake") {
        typeList = filteredApiData
          .map(i => i.intake)
          .filter(Boolean);
      }

      // ✅ WTP (FIXED)
      if (activeType === "wtp") {
        typeList = filteredApiData.flatMap(item =>
          (item.wtpUnits || []).map(unit => unit.wtp)
        ).filter(Boolean);
      }

      // ✅ OHT (FIXED)
      if (activeType === "oht") {
        typeList = filteredApiData.flatMap(item =>
          (item.wtpUnits || []).flatMap(unit => unit.ohts || [])
        ).filter(Boolean);
      }

          setTableDataINTEK(typeList);
          // BHUPEN
          // setTableData(typeList);

    } catch (err) {
      console.error(err);
    }
  }, [apiResponse, selectedFilter, activeType]);



  const filteredData = tableData.filter((item) => {
    // Department filter
    const matchDepartment = departmentFilter
      ? item.department_Name === departmentFilter
      : true;

    // Search filter
    const search = searchText.toLowerCase();

    const matchSearch =
      item.intakeId?.toString().toLowerCase().includes(search) ||
      item.department_Name?.toLowerCase().includes(search) ||
      item.ulbName?.toLowerCase().includes(search) ||
      item.intakeName?.toLowerCase().includes(search) ||
      item.wtpName?.toLowerCase().includes(search);

    return matchDepartment && (searchText ? matchSearch : true);
  });
  //19JUN 2026


  // =====================================================
  // PAGE LOAD
  // =====================================================
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        await handleTabClickForFeature();

      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);
  // =====================================================
  // API CALL
  // =====================================================

  const handleTabClickForFeature = async () => {

    try {

      const response = await fetch(
        "https://urbangis.mp.gov.in/api/Station_Data/GetScadaWTPDataNEW",
        {

          method: "POST",

          headers: {
            "Content-Type":
              "application/json",
          },

          body: JSON.stringify({

            intakeID: null,

            distCd: null,

            ulbCd: null,
          }),
        }
      );

      const result = await response.json();

      console.log("INTEK WELL 24JUN 2026 :-   API RESULT", result);

      setapiResponse(result);

      // FILTER DATA

      const transformed =
        transformScadaWtpData(result);

      setDATA(transformed);

      // TABLE DATA

      const table =
        buildAnalysisTable(result);

      //alert(result);

      setTableData(table);

    } catch (error) {

      console.error(
        "Error fetching SCADA data:",
        error
      );
    }
  };


const buildAnalysisTable = (result) => {
  const data = result?.data || [];

  if (!Array.isArray(data)) return [];

  const finalTable = [];

  data.forEach((item) => {
    const intake = item?.intake || {};
    const wtpUnits = item?.wtpUnits || [];

    wtpUnits.forEach((unit) => {
      const wtp = unit?.wtp || {};
      const ohts = unit?.ohts || [];

     



      finalTable.push({
        sno: finalTable.length + 1,

        // =================================================
        // INTAKE
        // =================================================

        intakeId: intake?.intakeId || "",
        intakeName: intake?.intakeWellName || "",
        schemeName: intake?.schemeName || "",
        intakeLevel: intake?.intakeWellLevel ?? 0,
        intakeOutletFlow: intake?.outletFlow ?? 0,

        //  intakeOutletFlow:
        //   [
        //     "0117",
        //     "0431",
        //     "0187",
        //     "0133",
        //     "0201",
        //     "0360",
        //     "0181",
        //     "0111",
        //     "0104",
        //   ].includes(String(intake?.ulb_Code || intake?.ulb_Code))
        //     ? ((intake?.outletFlow ?? 0) / 1000).toFixed(2)
        //     : (intake?.outletFlow ?? 0).toFixed(2),




        intakePressure: intake?.headerActualPressure ?? 0,
        intakeVendor: intake?.vendor_Name || "",
        intakeDepartment: intake?.department_Name || "",
        intakeDateTime: intake?.recordDateTime || "",

        // =================================================
        // LOCATION
        // =================================================

        ulbCode: intake?.ulb_Code || wtp?.ulb_Code || "",
        districtCode:
          intake?.district_Code || wtp?.district_Code || "",

        ulbName: intake?.ulbName || wtp?.ulbName || "",
        districtName:
          intake?.districtName || wtp?.districtName || "",

        latitude: intake?.intake_lat || 0,
        longitude: intake?.intake_long || 0,




  
        //  alert(finalTable);

        // =================================================
        // WTP
        // =================================================

        wtpId: wtp?.wtP_Device_id || "",
        wtpName: wtp?.wtP_Name || "",
       
  wtpInletFlow:
          [
            "0117",
            "0431",
            "0187",
            "0133",
            "0201",
            "0360",
            "0181",
            "0111",
            "0104",
            "0396",
          ].includes(String(intake?.ulb_Code || wtp?.ulb_Code))
            ? ((wtp?.inletFlow_mld ?? 0) / 1000).toFixed(2)
            : (wtp?.inletFlow_mld ?? 0 ).toFixed(2),





       wtpOutletFlow:
  [
    "0117",
    "0431",
    "0187",
    "0133",
    "0201",
    "0360",
    "0181",
    "0111",
    "0104",
    "0396",
  ].includes(String(intake?.ulb_Code || wtp?.ulb_Code))
    ? ((wtp?.outletFlow_mld ?? 0) / 1000).toFixed(2)
    : (wtp?.outletFlow_mld ?? 0).toFixed(2),


        wtpPressure: wtp?.headerActualPressure ?? 0,
        chlorine: wtp?.chlorine ?? 0,
        treatedPh: wtp?.treatedPh ?? 0,
        treatedTurbidity: wtp?.treatedTurbidity ?? 0,
        department_Name: wtp?.department_Name || "",

        // =================================================
        // OHT
        // =================================================

        ohtCount: ohts.length,

        ohtNames: ohts
          .map((o) => o?.ohT_Name)
          .join(", "),

       ohtTotalFlow: (
  [
    "0117",
    "0431",
    "0187",
    "0133",
    "0201",
    "0360",
    "0181",
    "0111",
    "0104",
    "0396",
  ].includes(String(intake?.ulb_Code))
    ? ohts.reduce(
        (sum, o) => sum + (o?.inletFlow_mld ?? 0),
        0
      ) / 1000
    : ohts.reduce(
        (sum, o) => sum + (o?.inletFlow_mld ?? 0),
        0
      )
).toFixed(2), 

        ohtAverageLevel:
          ohts.length > 0
            ? (
                ohts.reduce(
                  (sum, o) =>
                    sum + (o?.waterLevel_mld ?? 0),
                  0
                ) / ohts.length
              ).toFixed(2)
            : 0,

        // =================================================
        // PUMPS
        // =================================================

        intakePumpCount:
          item?.intakePumps?.length || 0,

        wtpPumpCount:
          unit?.pumps?.length || 0,
      });
    });
  });

  return finalTable;
};




  //  TABLE FILTER 



  const enrichedCards = cards.map((card) => {
    const data = apiResponse?.data?.data;

    const intake = data?.intake;
    const wtp = data?.wtpUnits?.[0]?.wtp;
    const ohts = data?.wtpUnits?.[0]?.ohts || [];

    let row = {};

    if (card.type === "intake") {
      row = {
        id: 1,
        ulb: intake?.ulb_Code,
        district: intake?.district_Code,
        name: intake?.intakeWellName,
        level: intake?.intakeWellLevel,
        flow: intake?.outletFlow,
      };
    }

    if (card.type === "wtp") {
      row = {
        name: wtp?.wtP_Name,
        inlet: wtp?.inletFlow_mld,
        outlet: wtp?.outletFlow_mld,
      };
    }

    if (card.type === "oht") {
      const oht = ohts?.[card.index];

      row = {
        name: oht?.ohT_Name,
        flow: oht?.inletFlow_mld,
        level: oht?.waterLevel_mld,
      };
    }

    return {
      ...card,
      row,
    };
  });


  // =====================================================
  // FILTER
  // =====================================================
  const filteredRows = useMemo(() => {

    return selectedFilter === "all"

      ? DATA

      : DATA.filter(
        (row) =>
          row.intakewell === selectedFilter
      );

  }, [selectedFilter, DATA]);

  // =====================================================
  // FILTER OPTIONS
  // =====================================================

  // const intakeOptions = useMemo(() => {

  //   return unique(DATA, "intakewell");

  // }, [DATA]);

  const intakeOptions = [
    "all",
    ...new Set(
      apiResponse?.data?.map(
        (item) => item?.intake?.schemeName
      )
    ),
  ];

  // =====================================================
  // GROUP DATA
  // =====================================================

  const grouped = useMemo(() => {

    return groupData(filteredRows);

  }, [filteredRows]);




  useEffect(() => {
    const tick = () => setClock(new Date().toLocaleTimeString());
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  // =====================================================
  // BUILD NETWORK
  // =====================================================

  // CODE FOR DOWNLOAD



  // SEARCH DATA FROM HERE

  // SEARCH DATA FROM HERE




  // =====================================================
  // BUILD NETWORK
  // =====================================================


  // const [loading, setLoading] = useState(true);

  useEffect(() => {
    const buildNetwork = async () => {

      try {
        setLoading(true); // 🔥 START LOADER

        // ================================
        // API DATA
        // ================================

        const apiData = Array.isArray(apiResponse?.data)
          ? apiResponse.data
          : [];

        // ✅ Set default filter ONLY if not set
        let activeFilter = selectedFilter;

        if (!activeFilter && apiData.length > 0) {
          activeFilter = apiData[0]?.intake?.schemeName;
          setSelectedFilter(activeFilter);
        }

        // ================================
        // FILTER DATA
        // ================================

        const filteredApiData =
          activeFilter === "all"
            ? apiData
            : apiData.filter(
              (item) =>
                item?.intake?.schemeName === activeFilter
            );

        // alert("FilterAPI");
        // alert(JSON.stringify(filteredApiData, null, 2));

        // ================================
        // LAYOUT
        // ================================

        const X = { intake: 60, wtp: 500, oht: 950 };

        const nodeW = 200;
        const nodeH = 120;

        const ohtGap = 150;
        const wtpGap = 120;
        const intakeGap = 180;

        let yCursor = 80;
        let totalFlow = 0;
        let pipeTotal = 0;

        const builtNodes = [];
        const builtCards = [];

        // ================================
        // LOOP API
        // ================================

        filteredApiData.forEach((item) => {

          const intakeObj = item?.intake;
          const wtps = item?.wtpUnits || [];

          let intakeHeight = 0;

          wtps.forEach((unit) => {
            const ohts = unit?.ohts || [];

            intakeHeight +=
              Math.max(
                nodeH + 28,
                (ohts.length - 1) * ohtGap + nodeH
              ) + wtpGap;
          });

          const intakeY =
            yCursor + intakeHeight / 2 - nodeH / 2;

          // INTAKE NODE
          // builtNodes.push({
          //   key: intakeObj?.intakeId,
          //   name: intakeObj?.intakeWellName,
          //   typeName: "Intake Well",
          //   type: "intake",
          //   x: X.intake,
          //   y: intakeY,
          //   flow: intakeObj?.outletFlow || 0,
          //   outletFlow: intakeObj?.outletFlow,
          //   intakeLevel: intakeObj?.intakeWellLevel,
          //   designPressure: intakeObj?.headerDesignPressure,
          //   actualPressure: intakeObj?.headerActualPressure,
          //   powerFactor: intakeObj?.power_factor,
          //   vendorName: intakeObj?.vendor_Name
          // });


          // ================================
          // INTAKE NODE
          // ================================
          builtNodes.push({
            key: intakeObj?.intakeId,

            // Basic
            name: intakeObj?.intakeWellName || "Unknown Intake",
            typeName: "Intake Well",
            type: "intake",

            // Position
            x: X.intake,
            y: intakeY,

            // Flow / Level
            flow: Number(intakeObj?.outletFlow) || 0,

            // 19 AUG  
           // outletFlow: Number(intakeObj?.outletFlow) || 0,

           outletFlow:
          [
            "0117",
            "0431",
            "0187",
            "0133",
            "0201",
            "0360",
            "0181",
            "0111",
            "0104",
          ].includes(String(intakeObj?.ulb_Code || intakeObj?.ulb_Code))
            ? ((intakeObj?.outletFlow ?? 0) / 1000).toFixed(2)
            : (intakeObj?.outletFlow ?? 0).toFixed(2),


            intakeLevel: Number(intakeObj?.intakeWellLevel) || 0,

            // Pressure
            designPressure:
              Number(intakeObj?.headerDesignPressure) || 0,

            actualPressure:
              Number(intakeObj?.headerActualPressure) || 0,

            // Electrical
            powerConsumption:
              Number(intakeObj?.power_consumption_w) || 0,

            powerFactor:
              Number(intakeObj?.power_factor) || 0,

            // Location
            latitude:
              Number(intakeObj?.intake_lat) || 0,

            longitude:
              Number(intakeObj?.intake_long) || 0,

            // Administrative
            districtCode:
              intakeObj?.district_Code || "",

            districtName:
              intakeObj?.districtName || "",

            ulbCode:
              intakeObj?.ulb_Code || "",

            ulbName:
              intakeObj?.ulbName || "",

            // Scheme
            schemeName:
              intakeObj?.schemeName || "",

            // Organization
            vendorName:
              intakeObj?.vendor_Name || "",

            departmentName:
              intakeObj?.department_Name || "",

            // Last update
            recordDateTime:
              intakeObj?.recordDateTime || ""
          });





          totalFlow += intakeObj?.outletFlow || 0;

          let wtpCursor = yCursor;

          wtps.forEach((unit) => {

            const wtp = unit?.wtp;
            const ohts = unit?.ohts || [];

            const ohtHeight = Math.max(
              nodeH + 28,
              (ohts.length - 1) * ohtGap + nodeH
            );

            const wtpY =
              wtpCursor + ohtHeight / 2 - nodeH / 2;

            // WTP NODE
            builtNodes.push({
              key: wtp?.wtP_Device_id,
              name: wtp?.wtP_Name,
              typeName: "WTP",
              type: "wtp",
              x: X.wtp,
              y: wtpY,

            //  flow: wtp?.outletFlow_mld || 0,

               flow:
          [
            "0117",
            "0431",
            "0187",
            "0133",
            "0201",
            "0360",
            "0181",
            "0111",
            "0104",
          ].includes(String(wtp?.ulb_Code || wtp?.ulb_Code))
            ? ((wtp?.inletFlow_mld ?? 0) / 1000).toFixed(2)
            : (wtp?.inletFlow_mld ?? 0 ).toFixed(2),



             // outletFlow_mld: wtp?.outletFlow_mld,

               outletFlow_mld:
          [
            "0117",
            "0431",
            "0187",
            "0133",
            "0201",
            "0360",
            "0181",
            "0111",
            "0104",
          ].includes(String(wtp?.ulb_Code || wtp?.ulb_Code))
            ? ((wtp?.outletFlow_mld ?? 0) / 1000).toFixed(2)
            : (wtp?.outletFlow_mld ?? 0 ).toFixed(2),

              treatedPh: wtp?.treatedPh,
              treatedTurbidity: wtp?.treatedTurbidity,
              chlorine: wtp?.chlorine,
              cwrLevel: wtp?.cwrLevel
            });

            totalFlow += wtp?.outletFlow_mld || 0;

            // PIPE: INTAKE -> WTP
            builtCards.push({
              key: `${intakeObj?.intakeId}-${wtp?.wtP_Device_id}`,
              x1: X.intake + nodeW,
              y1: intakeY + nodeH / 2,
              x2: X.wtp,
              y2: wtpY + nodeH / 2
            });

            pipeTotal++;

            const startY =
              wtpY + nodeH / 2 - ohtHeight / 2;

            ohts.forEach((oht, index) => {

              const ohtY = startY + index * ohtGap;

              builtNodes.push({
                key: oht?.ohT_Device_id,
                name: oht?.ohT_Name,
                type: "oht",
                x: X.oht,
                y: ohtY,
                flow_oht26: oht?.inletFlow_mld,
                waterLevel_mld: oht?.waterLevel_mld,
                residualChlorine: oht?.residualChlorine,
                inletPressure: oht?.inletPressure
              });

              totalFlow += oht?.inletFlow_mld || 0;


              

              // PIPE: WTP -> OHT
              builtCards.push({
                key: `${wtp?.wtP_Device_id}-${oht?.ohT_Device_id}`,
                x1: X.wtp + nodeW,
                y1: wtpY + nodeH / 2,
                x2: X.oht,
                y2: ohtY + nodeH / 2
              });

              pipeTotal++;
            });

            wtpCursor += ohtHeight + wtpGap;
          });

          yCursor += intakeHeight + intakeGap;
        });

        // ================================
        // SET DATA
        // ================================

        setNodes(builtNodes);
        setCards(builtCards);

        setTelemetry({
          intakeCount: filteredApiData.length,
          wtpCount: filteredApiData.reduce(
            (sum, item) => sum + (item?.wtpUnits?.length || 0),
            0
          ),
          ohtCount: filteredApiData.reduce(
            (sum, item) =>
              sum +
              item?.wtpUnits?.reduce(
                (s, unit) => s + (unit?.ohts?.length || 0),
                0
              ),
            0
          ),
          flowValue: totalFlow,
          pipeCount: pipeTotal
        });

      } catch (err) {
        console.error("Network Build Error:", err);
      } finally {
        setLoading(false); // ✅ STOP LOADER
      }
    };

    if (apiResponse?.data) {
      buildNetwork();

    }

  }, [selectedFilter, apiResponse]);
  // =====================================================
  // LIVE FLOW UPDATE
  // =====================================================

  useEffect(() => {

    const id = setInterval(() => {

      setNodes((prev) =>
        prev.map((node) => {

          // RANDOM FLOW ANIMATION

          let updatedFlow = node.flow || 0;

          if (node.type === "intake") {
            updatedFlow =
              Number(node.outletFlow || 0) +
              random(-50, 50);
          }

          if (node.type === "wtp") {
            updatedFlow =
              Number(node.outletFlow_mld || 0) +
              random(-20, 20);
          }

          if (node.type === "oht") {
            updatedFlow =
              Number(node.inletFlow_mld || 0) +
              random(-10, 10);
          }

          return {
            ...node,
            flow: Math.max(0, updatedFlow)
          };
        })
      );

      setTelemetry((prev) => ({

        ...prev,

        flowValue:
          nodes.reduce(
            (sum, node) =>
              sum + Number(node.flow || 0),
            0
          ),

        flowTrend:
          `+${random(2, 12)}%`,

        healthValue:
          random(91, 98),

        healthAngle:
          random(330, 352),

        pressure:
          random(74, 88),

        quality:
          random(88, 97),

        uptime:
          random(97, 100),

        avgPressure:
          `${(random(42, 54) / 10).toFixed(1)} bar`,

        tankLevel:
          `${random(72, 91)}%`
      }));

    }, 3000);

    return () => clearInterval(id);

  }, [nodes]);

  // =====================================================
  // BUILD NETWORK
  // =====================================================


  const healthStyle = { "--health-angle": `${telemetry.healthAngle}deg` };


  // CODE FOR CSS const
  // CODE BHUPEN 18MAY
  const tdStyle = {

    fontSize: "20px",
    border: "1px solid #07141b",
  };

  // CODE FOR  DISTRICT
  // BHUPEN_LOAD_DATA LIVE
const downloadExcel8 = async () => {
  const element = document.getElementById("pdfTable");

  if (!element) {
    alert("Table not found");
    return;
  }

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#ffffff",
    logging: false,
  });

  const pdf = new jsPDF("l", "mm", "a4");

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const margin = 5;
  const usableWidth = pageWidth - margin * 2;
  const usableHeight = pageHeight - margin * 2;

  // Width/height ratio
  const imgWidth = usableWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  // Height of one PDF page in original canvas pixels
  const pageCanvasHeight =
    (usableHeight * canvas.width) / imgWidth;

  let position = 0;
  let pageNumber = 0;

  while (position < canvas.height) {
    const remainingHeight = canvas.height - position;

    const currentCanvasHeight = Math.min(
      pageCanvasHeight,
      remainingHeight
    );

    // Create temporary canvas for current page
    const pageCanvas = document.createElement("canvas");

    pageCanvas.width = canvas.width;
    pageCanvas.height = currentCanvasHeight;

    const ctx = pageCanvas.getContext("2d");

    ctx.fillStyle = "#ffffff";
    ctx.fillRect(
      0,
      0,
      pageCanvas.width,
      pageCanvas.height
    );

    ctx.drawImage(
      canvas,
      0,
      position,
      canvas.width,
      currentCanvasHeight,
      0,
      0,
      canvas.width,
      currentCanvasHeight
    );

    const pageImgHeight =
      (currentCanvasHeight * imgWidth) / canvas.width;

    if (pageNumber > 0) {
      pdf.addPage();
    }

    pdf.addImage(
      pageCanvas.toDataURL("image/png"),
      "PNG",
      margin,
      margin,
      imgWidth,
      pageImgHeight,
      undefined,
      "FAST"
    );

    position += currentCanvasHeight;
    pageNumber++;
  }

  pdf.save("SCADA_WTP.pdf");
};
  // CODE FOR DOWNLOAD

  //CODE FOR DOUNLOAD
const downloadExcel = () => {
  if (!filteredData || filteredData.length === 0) {
    alert("No data available to download");
    return;
  }

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  // =========================
  // PAGE DETAILS
  // =========================
  const pageWidth = doc.internal.pageSize.getWidth();

  // =========================
  // TITLE
  // =========================
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);

  doc.text(
    "SCADA WTP Dashboard - Intake Details",
    pageWidth / 2,
    10,
    { align: "center" }
  );

  // =========================
  // DATE
  // =========================
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);

  doc.text(
    `Generated On: ${new Date().toLocaleString("en-IN")}`,
    pageWidth - 10,
    16,
    { align: "right" }
  );

  // =========================
  // TABLE HEADERS
  // =========================
  const headers = [
    "S.No",
    "Intake ID",
    "Department Name",
    "ULB Name",
    "Intake Well Name",
    "Intake Level (M)",
    "Intake Flow (MLD)",
    "WTP Name",
    "pH",
    "Chlorine (ppm)",
    "Turbidity (NTU)",
    "WTP In Flow (MLD)",
    "WTP Out Flow (MLD)",
    "OHT Count",
    "OHT In Flow (MLD)",
    "Last Data",
  ];

  // =========================
  // TABLE DATA
  // =========================
  const rows = filteredData.map((item, index) => {
    const intakeDate = item.intakeDateTime
      ? new Date(item.intakeDateTime)
      : null;

    const today = new Date();

    const isToday =
      intakeDate &&
      intakeDate.getDate() === today.getDate() &&
      intakeDate.getMonth() === today.getMonth() &&
      intakeDate.getFullYear() === today.getFullYear();

    let lastData = "-";

    if (intakeDate) {
      lastData =
        `${intakeDate.toLocaleString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        })}\n` +
        `${isToday ? "ONLINE" : "OFFLINE"}`;
    } else {
      lastData = "OFFLINE";
    }

    return [
      index + 1,
      item.intakeId ?? "-",
      item.department_Name ?? "-",
      item.ulbName ?? "-",
      item.intakeName ?? "-",
      item.intakeLevel ?? "-",
      item.intakeOutletFlow ?? 0,
      item.wtpName ?? "-",
      item.treatedPh ?? "-",
      item.chlorine ?? "-",
      item.treatedTurbidity ?? "-",
      item.wtpInletFlow ?? 0,
      item.wtpOutletFlow ?? 0,
      item.ohtCount ?? 0,
      item.ohtTotalFlow != null
        ? Number(item.ohtTotalFlow).toFixed(2)
        : "0.00",
      lastData,
    ];
  });

  // =========================
  // PDF TABLE
  // =========================
  autoTable(doc, {
    startY: 20,

    head: [headers],

    body: rows,

    theme: "grid",

    styles: {
      font: "helvetica",
      fontSize: 6.5,
      cellPadding: 1.5,
      lineColor: [180, 190, 195],
      lineWidth: 0.2,
      valign: "middle",
      halign: "center",
      overflow: "linebreak",
    },

    headStyles: {
      fillColor: [11, 104, 104],
      textColor: [255, 255, 255],
      fontStyle: "bold",
      fontSize: 6.5,
      halign: "center",
      valign: "middle",
    },

    alternateRowStyles: {
      fillColor: [248, 250, 252],
    },

    columnStyles: {
      0: { cellWidth: 8 },
      1: { cellWidth: 18 },
      2: { cellWidth: 25 },
      3: { cellWidth: 22 },
      4: { cellWidth: 25 },
      5: { cellWidth: 15 },
      6: { cellWidth: 17 },
      7: { cellWidth: 25 },
      8: { cellWidth: 10 },
      9: { cellWidth: 17 },
      10: { cellWidth: 17 },
      11: { cellWidth: 18 },
      12: { cellWidth: 18 },
      13: { cellWidth: 12 },
      14: { cellWidth: 18 },
      15: { cellWidth: 25 },
    },

    margin: {
      top: 20,
      left: 5,
      right: 5,
      bottom: 12,
    },

    didParseCell: function (data) {
      // Last Data column
      if (
        data.section === "body" &&
        data.column.index === 15
      ) {
        const value = String(data.cell.raw || "");

        if (value.includes("ONLINE")) {
          data.cell.styles.textColor = [21, 128, 61];
          data.cell.styles.fontStyle = "bold";
        }

        if (value.includes("OFFLINE")) {
          data.cell.styles.textColor = [220, 38, 38];
          data.cell.styles.fontStyle = "bold";
        }
      }
    },

    didDrawPage: function (data) {
      // Footer
      const pageNumber =
        doc.internal.getNumberOfPages();

      doc.setFontSize(7);
      doc.setFont("helvetica", "normal");

      doc.text(
        `Page ${pageNumber}`,
        pageWidth / 2,
        doc.internal.pageSize.getHeight() - 5,
        {
          align: "center",
        }
      );
    },
  });

  // =========================
  // DOWNLOAD
  // =========================
  doc.save(
    `SCADA_Intake_Report_${new Date()
      .toISOString()
      .slice(0, 10)}.pdf`
  );
};
  //CODE FOR 



  const countValue = {
    fontSize: "26px",
    fontWeight: "700",
    color: "#000"
  };
  // CODE FOR DISTRICT

  /* COMMON STYLE */


  //26MAY 
  //BHUPEN_CSS FOR TABLE BOTTOM LAYOUT


  const styles = {
    container: {
      width: "100%",
      background: "#ffffff",

      borderRadius: "8px",
      border: "1px solid black",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      fontFamily: "Arial, sans-serif",
      overflow: "auto"
    },
    heading: {
      marginBottom: "10px",
      fontSize: "16px",
      fontWeight: "bold",
      color: "#333"
    },
    loading: {
      color: "#666",
      fontSize: "14px"
    },
    tableWrapper: {
      maxHeight: "200px",
      overflowY: "auto",
      overflowX: "auto",
      border: "1px solid #ddd",
      borderRadius: "6px"
    },

    table: {
      width: "100%",
      height: "200px",
      borderCollapse: "collapse",
      fontFamily: "Arial, sans-serif"
    },
    th: {
      border: "1px solid #333",
      padding: "8px",
      textAlign: "center",
      backgroundColor: "#f2f2f2",
      fontWeight: "bold"
    },
    td: {
      border: "1px solid #333",
      padding: "8px",
      textAlign: "center"
    },
    evenRow: {
      backgroundColor: "#fafafa"
    },
    hoverRow: {
      backgroundColor: "#e6f2ff"
    }


  };
  const cardHeader = {
    background: "linear-gradient(90deg, rgba(174, 203, 214, 1) 0%, rgba(221, 236, 227, 1) 50%, rgba(245, 245, 245, 1) 100%)",
    borderRadius: "4px", overflow: "auto",
    fontSize: "18px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "14px",
    color: "#333"
  };
  const countBox = {
    textAlign: "center",
    padding: "10px",
    background: "linear-gradient(90deg, rgba(174, 203, 214, 1) 0%, rgba(221, 236, 227, 1) 50%, rgba(245, 245, 245, 1) 100%)",
    borderRadius: "4px", overflow: "auto",
    border: "1px solid #aaa",
    boxShadow: "inset 0 2px 4px rgba(0,0,0,0.2)"
  };

  const loaderWrapper = {
    position: "fixed",
    inset: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // 👇 dim transparent dark overlay
    background: "rgba(0, 40, 80, 0.35)",
    // optional blur effect (nice UI look)
    backdropFilter: "blur(1px)",
    zIndex: 99999,
  };


  const intakeLabelStyle = {
    border: "1px solid #031828",
    padding: "4px 5px",
    fontWeight: "700",
    background: "#2193b0",
    whiteSpace: "nowrap"
  };

  const intakeValueStyle = {
    border: "1px solid #031828",
    padding: "4px 5px",
    background: "#6dd5ed",
    fontWeight: "600",
    textAlign: "right"
  };
  // const countValue = {
  //   fontSize: "26px",
  //   fontWeight: "700",
  //   color: "#000"
  // };
  //BHUPEN_CSS FOR TABLE BOTTOM LAYOUT
  if (loading) {
    return (
      <div style={loaderWrapper}>
        <img
          src="https://i.gifer.com/ZKZg.gif"
          alt="Loading..."
          style={{
            width: "120px",
            height: "120px",
            borderRadius: "4px;",
            background: "rgba(225, 210, 210, 0.35)",
            filter: "drop-shadow(0 0 15px #00bfff)",
          }}
        />
      </div>
    );
  }



  //10JUN RETURN  CODE BHUPEN 


  // Sorting
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction:
        prev.key === key && prev.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };


  // RETURN CODE BHUPEN


  // CODE FOR DOWNLOAD
  const downloadSearchExcel = () => {
    if (!filteredData.length) return;

    const data = filteredData.map((item, index) => {
      const obj = {};

      // ✅ S.NO
      obj["S.NO"] = index + 1;

      // ✅ Town / District
      obj["Town / District"] = `${item.ulbName}, ${item.districtName}`;

      // ✅ Dynamic Columns
      Object.keys(item)
        .filter(
          (key) => key !== "ulbName" && key !== "districtName"
        )
        .forEach((key) => {
          obj[key.toUpperCase()] =
            key === "recordDateTime"
              ? new Date(item[key]).toLocaleString()
              : item[key] ?? "-";
        });

      return obj;
    });

    // ✅ Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // ✅ Auto column width
    const colWidths = Object.keys(data[0]).map((key) => ({
      wch: Math.max(key.length + 5, 15),
    }));
    worksheet["!cols"] = colWidths;

    // ✅ Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Search Data");

    // ✅ File name
    const fileName = `table_data_${new Date()
      .toISOString()
      .slice(0, 10)}.xlsx`;

    // ✅ Download
    XLSX.writeFile(workbook, fileName);
  };

// MAP SHOW 
const handleALLToClick = (row) => {
    navigate("/SCADAWTPDetailsALL", {

    });
  };
  // CODE ROF


  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100%",
      }}
    >
      {/* ================= TOP ROW ================= */}
      <div
        style={{
          display: "flex",
          width: "100%",
          flexWrap: "wrap", // ✅ makes responsive
        }}
      >
        {/* ===== LEFT (80%) ===== */}
        <div
          style={{
            flex: "0 0 80%",
            maxWidth: "80%",
            minHeight: "300px",
            background: "#1e293b",
          }}
        >
          <section className={`map-panel ${isMapPanelMaximized ? "maximized-map-panel" : ""}`}>
            <button
              onClick={() =>
                setIsMapPanelMaximized(
                  !isMapPanelMaximized
                )
              }
              style={{
                position: "absolute",
                top: "120px",
                right: "5px",
                zIndex: 999999,

                background:
                  isMapPanelMaximized
                    ? "linear-gradient(145deg,rgba(177, 63, 34, 0.95),rgba(253, 251, 147, 0.92))"
                    : "linear-gradient(145deg,rgba(34, 98, 177, 0.95),rgba(147,197,253,0.92))",

                color: "#fff",
                border: "none",
                padding: "5px 5px",
                borderRadius: "4px",
                cursor: "pointer",
                fontWeight: "300",
                fontSize: "13px",
                minWidth: "100px",
                whiteSpace: "nowrap",
                overflow: "visible",
                boxShadow:
                  "0 4px 14px rgba(0,0,0,0.35)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              {isMapPanelMaximized
                ? "✕"
                : "🗖 Maximize"}
            </button>

            <div className="map-toolbar" >
              <div className="map-title">
                <div
                  className="panel-head"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "14px",
                    padding: "10px 14px",
                    background: "linear-gradient(145deg,#0f172a,#1e293b)",
                    borderRadius: "14px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    gap: "12px",
                    flexWrap: "wrap",
                  }}
                >
                  {/* LEFT SIDE DROPDOWN */}
                  <div
                    className="top-actions"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <label
                      className="control"
                      htmlFor="intakeFilter"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        background: "rgba(255,255,255,0.08)",
                        padding: "6px 10px",
                        borderRadius: "12px",
                        border: "1px solid rgba(255,255,255,0.08)",
                      }}
                    >
                      {/* ICON */}
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                        style={{
                          width: "18px",
                          height: "18px",
                          color: "#38bdf8",
                          flexShrink: 0,
                        }}
                      >
                        <path
                          d="M4 6h16M7 12h10M10 18h4"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>

                      {/* SMALL DROPDOWN */}
                      <select
                        id="intakeFilter"
                        value={selectedFilter}
                        onChange={(e) => setSelectedFilter(e.target.value)}
                        style={{
                          width: "200px",
                          background: "rgba(15,23,42,0.95)",
                          border: "1px solid rgba(255,255,255,0.12)",
                          outline: "none",
                          color: "#ffffff",
                          fontSize: "13px",
                          fontWeight: "600",
                          cursor: "pointer",
                          padding: "6px 10px",
                          borderRadius: "10px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
                        }}
                      >
                        <option value="all">All Schemes</option>

                        {intakeOptions.map((item, index) => (
                          <option
                            key={item}
                            value={item}
                            style={{
                              background:
                                index % 2 === 0 ? "#111827" : "#1e293b",
                              color:
                                index % 2 === 0 ? "#f8fafc" : "#cbd5e1",
                            }}
                          >
                            {index}-{item}
                          </option>
                        ))}
                      </select>
                    </label>
                  </div>

                  {/* RIGHT SIDE SELECTED VALUE */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",

                      background: "rgba(26, 142, 192, 0.12)",
                      border: "1px solid rgba(56,189,248,0.25)",
                      padding: "8px 14px",
                      borderRadius: "12px",
                      minWidth: "200px",
                      justifyContent: "center",
                    }}
                  >
                    {/* RIGHT ICON */}.

                    <div
                      style={{
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        background: "#031b0c",
                        boxShadow: "0 0 10px #4ade80",
                        animation: "liveBlink 1s infinite",
                      }}
                    />

                    <p
                      style={{
                        margin: 0,
                        color: "#f8fafc",
                        fontSize: "13px",
                        fontWeight: "700",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {selectedFilter === "all"
                        ? "All "
                        : "Scheme Name : " + selectedFilter}
                    </p>
                  </div>

                  <div
                    style={{
                      width: "120px",
                      padding: "10px",
                      borderRadius: "14px",
                      background: "linear-gradient(135deg, #00c6ff, #0072ff)",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(255,255,255,0.15)",
                      boxShadow: "0 8px 25px rgba(0,0,0,0.35)",
                      textAlign: "center",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px) scale(1.05)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <div style={{ color: "#fff", fontWeight: "600", fontSize: "13px" }}>
                      💧 Intake
                    </div>

                    <button
                      style={{
                        marginTop: "8px",
                        padding: "6px 16px",
                        borderRadius: "8px",
                        border: "none",
                        background: "#fff",
                        color: "#000000",
                        fontWeight: "700",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setActiveType("intake");
                        setShowPopup(true);
                      }}
                    >
                      {telemetry.intakeCount}
                    </button>
                  </div>
                  <div
                    style={{
                      width: "120px",
                      padding: "10px",
                      borderRadius: "14px",
                      background: "linear-gradient(135deg, #11998e, #38ef7d)",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(255,255,255,0.15)",
                      boxShadow: "0 8px 25px rgba(0,0,0,0.35)",
                      textAlign: "center",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px) scale(1.05)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <div style={{ color: "#fff", fontWeight: "600", fontSize: "13px" }}>
                      🏭 WTP
                    </div>

                    <button
                      style={{
                        marginTop: "8px",
                        padding: "6px 16px",
                        borderRadius: "8px",
                        border: "none",
                        background: "#fff",
                        color: "#11998e",
                        fontWeight: "700",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setActiveType("wtp");
                        setShowPopup(true);
                      }}
                    >
                      {telemetry.wtpCount}
                    </button>
                  </div>
                  <div
                    style={{
                      width: "120px",
                      padding: "10px",
                      borderRadius: "14px",
                      background: "linear-gradient(135deg, #6a11cb, #2575fc)",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(255,255,255,0.15)",
                      boxShadow: "0 8px 25px rgba(0,0,0,0.35)",
                      textAlign: "center",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px) scale(1.05)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <div style={{ color: "#fff", fontWeight: "600", fontSize: "13px" }}>
                      🗼 OHT
                    </div>

                    <button
                      style={{
                        marginTop: "8px",
                        padding: "6px 16px",
                        borderRadius: "8px",
                        border: "none",
                        background: "#fff",
                        color: "#6a11cb",
                        fontWeight: "700",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setActiveType("oht");
                        setShowPopup(true);
                      }}
                    >
                      {telemetry.ohtCount}
                    </button>
                  </div>


 
 <div
                    style={{
                      width: "120px",
                      padding: "10px",
                      borderRadius: "14px",
                      background: "linear-gradient(135deg, #6a11cb, #2575fc)",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(255,255,255,0.15)",
                      boxShadow: "0 8px 25px rgba(0,0,0,0.35)",
                      textAlign: "center",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px) scale(1.05)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <div style={{ color: "#fff", fontWeight: "600", fontSize: "13px" }}>
                     
                    </div>

                    <button
                      style={{
                        marginTop: "8px",
                        padding: "6px 16px",
                        borderRadius: "8px",
                        border: "none",
                        background: "#fff",
                        color: "#6a11cb",
                        fontWeight: "700",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                       handleALLToClick()
                      }}
                    >
                       SHOW On MAP 
                    </button>
                  </div>

                </div>
              </div>
            </div>

<aside
  className={isScadaFullscreen ? "scada-fullscreen" : ""}
  style={{
    height: isScadaFullscreen ? "100vh" : "500px",
    width: isScadaFullscreen ? "100vw" : "100%",
    position: isScadaFullscreen ? "fixed" : "relative",
    top: isScadaFullscreen ? 0 : "auto",
    left: isScadaFullscreen ? 0 : "auto",
    zIndex: isScadaFullscreen ? 99999 : 1,
    overflow: "hidden",
    background:
      "radial-gradient(circle at 50% 50%, #0b2733 0%, #061923 45%, #020b11 100%)",
    border: "1px solid #164e63",
    boxShadow:
      "inset 0 0 40px rgba(0,200,255,0.08), 0 8px 25px rgba(0,0,0,0.45)",
  }}
>

 <div
  className="canvas-wrap"
  style={{
    width: "100%",
    height: "100%",
    position: "relative",
    overflow: "auto",
    background:
      "linear-gradient(rgba(14,116,144,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(14,116,144,0.08) 1px, transparent 1px)",
    backgroundSize: "35px 35px",
  }}
>

    {loading ? (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "#67e8f9",
          background:
            "radial-gradient(circle, #082f49, #020617)",
        }}
      >
        <div className="scada-loader">
          <div className="loader-ring"></div>
          <div className="loader-ring loader-ring-2"></div>
          <div className="loader-core">SCADA</div>
        </div>

        <div
          style={{
            marginTop: "5px",
            fontSize: "12px",
            fontWeight: "700",
            letterSpacing: "2px",
            color: "#67e8f9",
          }}
        >
          INITIALIZING NETWORK...
        </div>
      </div>
    ) : (
      <div
        className="network scada-network"
        id="network"
        style={{
          minWidth: "1000px",
          minHeight: "520px",
          position: "relative",
          background:
            "radial-gradient(circle at center, rgba(73, 65, 8, 0.35), rgba(2,8,15,0.85))",
        }}
      >

{/* FULL SCREEN CONTROLS */}
<div
  style={{
    position: "absolute",
    top: "8px",
    right: "12px",
    zIndex: 100000,
    display: "flex",
    gap: "6px",
  }}
>
 

  {isScadaFullscreen && (
    <button
      type="button"
      onClick={() => setIsScadaFullscreen(false)}
      style={{
        width: "34px",
        height: "30px",
        border: "1px solid rgba(239,68,68,0.5)",
        borderRadius: "6px",
        background: "rgba(40,10,10,0.9)",
        color: "#fca5a5",
        cursor: "pointer",
        fontSize: "16px",
        fontWeight: "bold",
      }}
      title="Close Full Screen"
    >
      ✕
    </button>
  )}
</div>
        {/* =========================================
            LANES
        ========================================= */}

        <div className="lane lane-intake">
          <span>01</span>
          INTAKE
        </div>

        <div className="lane lane-wtp">
          <span>02</span>
          TREATMENT
        </div>

        <div className="lane lane-oht">
          <span>03</span>
          STORAGE
        </div>


        {/* =========================================
            SVG PIPE NETWORK
        ========================================= */}

        <svg
          id="svgCanvas"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            zIndex: 1,
            pointerEvents: "none",
            overflow: "visible",
          }}
        >

          <defs>

            <linearGradient
              id="pipeGradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%"
            >
              <stop
                offset="0%"
                stopColor="#0ea5e9"
              />

              <stop
                offset="50%"
                stopColor="#22d3ee"
              />

              <stop
                offset="100%"
                stopColor="#22c55e"
              />
            </linearGradient>

            <filter
              id="pipeGlow"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feGaussianBlur
                stdDeviation="4"
                result="blur"
              />

              <feMerge>
                <feMergeNode in="blur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>

            <filter
              id="nodeGlow"
              x="-100%"
              y="-100%"
              width="300%"
              height="300%"
            >
              <feGaussianBlur
                stdDeviation="5"
                result="blur"
              />

              <feMerge>
                <feMergeNode in="blur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>

          </defs>


          {cards.map((card) => {

            const x1 = card.x1;
            const y1 = card.y1;
            const x2 = card.x2;
            const y2 = card.y2;

            const curve = Math.max(
              78,
              Math.abs(x2 - x1) * 0.32
            );

            const d = `
              M ${x1} ${y1}
              C ${x1 + curve} ${y1},
                ${x2 - curve} ${y2},
                ${x2} ${y2}
            `;

            return (
              <g key={card.key}>

                {/* PIPE SHADOW */}

                <path
                  d={d}
                  fill="none"
                  stroke="#000"
                  strokeWidth="12"
                  opacity="0.5"
                />

                {/* PIPE BODY */}

                <path
                  d={d}
                  fill="none"
                  stroke="#164e63"
                  strokeWidth="8"
                  strokeLinecap="round"
                />

                {/* FLOW PIPE */}

                <path
                  d={d}
                  fill="none"
                  stroke="url(#pipeGradient)"
                  strokeWidth="4"
                  strokeLinecap="round"
                  filter="url(#pipeGlow)"
                  strokeDasharray="14 8"
                  className="animated-pipe"
                />


                {/* FLOW PARTICLE 1 */}

                <circle
                  r="5"
                  fill="#67e8f9"
                  filter="url(#pipeGlow)"
                >
                  <animateMotion
                    path={d}
                    dur="2.5s"
                    begin="0s"
                    repeatCount="indefinite"
                  />
                </circle>


                {/* FLOW PARTICLE 2 */}

                <circle
                  r="3"
                  fill="#22c55e"
                >
                  <animateMotion
                    path={d}
                    dur="3.5s"
                    begin="0.8s"
                    repeatCount="indefinite"
                  />
                </circle>


                {/* FLOW PARTICLE 3 */}

                <circle
                  r="2.5"
                  fill="#38bdf8"
                >
                  <animateMotion
                    path={d}
                    dur="4s"
                    begin="1.5s"
                    repeatCount="indefinite"
                  />
                </circle>

              </g>
            );
          })}

        </svg>


        {/* =========================================
            NODES
        ========================================= */}

        {nodes.map((node) => {

          const flowValue =
            Number(
              node.flow ||
              node.outletFlow ||
              node.outletFlow_mld ||
              node.flow_oht26 ||
              0
            );

          const level = Math.max(
            10,
            Math.min(
              100,
              Math.round(flowValue * 4)
            )
          );

          return (
            <article
              key={
                node.key +
                node.type +
                node.x +
                node.y
              }
              className={`node ${node.type} scada-node`}
              style={{
                left: `${node.x}px`,
                top: `${node.y}px`,
                position: "absolute",
                zIndex: 10,
              }}
            >

              {/* =================================
                  NODE HEADER
              ================================= */}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >

                {/* NODE ICON */}

                <div
                  className="scada-node-icon"
                  style={{
                    position: "relative",
                    width: "34px",
                    height: "34px",
                    minWidth: "34px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background:
                      "radial-gradient(circle, #164e63, #020617)",
                    border:
                      "2px solid #22d3ee",
                    color: "#67e8f9",
                    boxShadow:
                      "0 0 15px rgba(34,211,238,0.55)",
                  }}
                >
                  {ICONS[node.type]}

                  <span className="node-pulse"></span>
                </div>


                {/* NAME */}

                <div
                  style={{
                    minWidth: 0,
                    flex: 1,
                  }}
                >

                  <div
                    style={{
                      maxWidth: "120px",
                      fontSize: "11px",
                      fontWeight: "800",
                      color: "#f8fafc",
                      lineHeight: "1.2",
                      whiteSpace: "normal",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {node.name}
                  </div>

                  <div
                    style={{
                      marginTop: "2px",
                      fontSize: "8px",
                      fontWeight: "700",
                      color: "#38bdf8",
                      letterSpacing: "0.8px",
                    }}
                  >
                    {node.typeName}
                  </div>

                </div>


                {/* LIVE STATUS */}

               

              </div>


              {/* =================================
                  FLOW BAR
              ================================= */}

              <div
                style={{
                  marginTop: "7px",
                  height: "5px",
                  width: "100%",
                  background:
                    "rgba(15,23,42,0.9)",
                  border:
                    "1px solid rgba(56,189,248,0.15)",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
              >

                <div
                  className="scada-flow-bar"
                  style={{
                    width: `${level}%`,
                    height: "100%",
                    borderRadius: "10px",
                    background:
                      "linear-gradient(90deg,#06b6d4,#22d3ee,#22c55e)",
                  }}
                />

              </div>


              {/* =================================
                  INTAKE TELEMETRY
              ================================= */}

              {node.type === "intake" && (

                <div className="scada-telemetry-box">

                  <div className="telemetry-grid">

                    <div>
                      <span>LEVEL</span>
                      <strong>
                        {Number(
                          node.intakeLevel || 0
                        ).toFixed(2)}
                        <small> m</small>
                      </strong>
                    </div>

                    <div>
                      <span>FLOW</span>
                      <strong>
                        {Number(
                          node.outletFlow || 0
                        ).toFixed(2)}
                        <small> MLD</small>
                      </strong>
                    </div>

                    <div>
                      <span>PRESSURE</span>
                      <strong>
                        {Number(
                          node.actualPressure || 0
                        ).toFixed(2)}
                        <small> bar</small>
                      </strong>
                    </div>

                    <div>
                      <span>POWER</span>
                      <strong>
                        {Number(
                          node.powerConsumption || 0
                        ).toFixed(0)}
                        <small> W</small>
                      </strong>
                    </div>

                    <div>
                      <span>PF</span>
                      <strong>
                        {Number(
                          node.powerFactor || 0
                        ).toFixed(2)}
                      </strong>
                    </div>

                   

                  </div>

                  <div className="telemetry-footer">
                    <span>
                      SCHEME
                    </span>

                    <strong>
                      {node.schemeName || "-"}
                    </strong>
                  </div>

                </div>
              )}


              {/* =================================
                  WTP TELEMETRY
              ================================= */}

              {node.type === "wtp" && (

                <div className="scada-telemetry-box wtp-box">

                  <div className="telemetry-grid">

                    <div>
                      <span>FLOW</span>
                      <strong>
                        {Number(
                          node.outletFlow_mld || 0
                        ).toFixed(2)}
                        <small> MLD</small>
                      </strong>
                    </div>

                    <div>
                      <span>pH</span>
                      <strong>
                        {Number(
                          node.treatedPh || 0
                        ).toFixed(2)}
                      </strong>
                    </div>

                    <div>
                      <span>TURBIDITY</span>
                      <strong>
                        {Number(
                          node.treatedTurbidity || 0
                        ).toFixed(2)}
                      </strong>
                    </div>

                    <div>
                      <span>CHLORINE</span>
                      <strong>
                        {Number(
                          node.chlorine || 0
                        ).toFixed(2)}
                      </strong>
                    </div>

                  </div>

                  <div className="telemetry-status">
                    <span className="scada-live-dot"></span>
                    TREATMENT 
                  </div>

                </div>
              )}


              {/* =================================
                  OHT TELEMETRY
              ================================= */}

              {node.type === "oht" && (

                <div className="scada-telemetry-box oht-box">

                  <div className="telemetry-grid three">

                    <div>
                      <span>FLOW</span>
                      <strong>
                        {Number(
                          node.flow_oht26 || 0
                        ).toFixed(2)}
                      </strong>
                    </div>

                    <div>
                      <span>LEVEL</span>
                      <strong>
                        {Number(
                          node.waterLevel_mld || 0
                        ).toFixed(2)}
                      </strong>
                    </div>

                    <div>
                      <span>PRESSURE</span>
                      <strong>
                        {Number(
                          node.inletPressure || 0
                        ).toFixed(2)}
                      </strong>
                    </div>

                  </div>

                  <div className="telemetry-status">
                    <span className="scada-live-dot"></span>
                    STORAGE 
                  </div>

                </div>
              )}

            </article>
          );
        })}


        {/* =========================================
            PUMP / FLOW ANIMATION
        ========================================= */}

        {enrichedCards.map((card) => (

          <div
            key={card.key + "-card"}
            className="flow-card scada-pump"
            style={{
              left:
                `${(card.x1 + card.x2) / 2 - 40}px`,
              top:
                `${(card.y1 + card.y2) / 2 - 40}px`,
              position: "absolute",
              zIndex: 15,
              pointerEvents: "none",
            }}
          >

            <div className="pump-ring">

              <img
                src={
                  card.image ||
                  "/img/pump.gif"
                }
                alt="flow"
                style={{
                  width: "55px",
                  height: "55px",
                  objectFit: "contain",                 
                  filter:
                    card.flow > 0
                      ? "drop-shadow(0 0 8px #088598)"
                      : "grayscale(1)",
                }}
              />

            </div>

          </div>
        ))}


      
      </div>
    )}
  </div>


  {/* =============================================
      SCADA ANIMATION CSS
  ============================================= */}

  <style>
    {`

      /* ==========================================
         PIPE FLOW
      ========================================== */

      .animated-pipe {
        animation: pipeFlow 1.2s linear infinite;
      }

      @keyframes pipeFlow {
        from {
          stroke-dashoffset: 0;
        }

        to {
          stroke-dashoffset: -45;
        }
      }


      /* ==========================================
         LIVE DOT
      ========================================== */

      .scada-live-dot {
        width: 7px;
        height: 7px;
        display: inline-block;
        border-radius: 50%;
        background: #22c55e;
        box-shadow:
          0 0 5px #22c55e,
          0 0 12px rgba(34,197,94,0.8);
        animation: scadaBlink 1.2s infinite;
      }

      @keyframes scadaBlink {

        0% {
          opacity: 1;
          transform: scale(1);
        }

        50% {
          opacity: 0.35;
          transform: scale(1.5);
        }

        100% {
          opacity: 1;
          transform: scale(1);
        }

      }


      /* ==========================================
         NODE PULSE
      ========================================== */

      .node-pulse {
        position: absolute;
        inset: -6px;
        border-radius: 50%;
        border: 1px solid rgba(34,211,238,0.6);
        animation: nodePulse 2s infinite;
      }

      @keyframes nodePulse {

        0% {
          transform: scale(0.8);
          opacity: 0.8;
        }

        70% {
          transform: scale(1.5);
          opacity: 0;
        }

        100% {
          transform: scale(1.5);
          opacity: 0;
        }

      }


      /* ==========================================
         FLOW BAR ANIMATION
      ========================================== */

      .scada-flow-bar {
        position: relative;
        overflow: hidden;
        box-shadow:
          0 0 8px rgba(34,211,238,0.8);
      }

      .scada-flow-bar::after {
        content: "";
        position: absolute;
        top: 0;
        left: -50%;
        width: 50%;
        height: 100%;
        background:
          linear-gradient(
            90deg,
            transparent,
            rgba(255,255,255,0.8),
            transparent
          );
        animation: flowShine 1.4s linear infinite;
      }

      @keyframes flowShine {

        from {
          left: -50%;
        }

        to {
          left: 120%;
        }

      }


      /* ==========================================
         SCADA NODE
      ========================================== */

      .scada-node {

        width: 170px;

        padding: 8px;

        border-radius: 10px;

        background:
          linear-gradient(
            145deg,
            rgba(7,37,50,0.97),
            rgba(2,15,23,0.98)
          );

        border:
          1px solid rgba(34,211,238,0.35);

        box-shadow:
          0 8px 25px rgba(0,0,0,0.55),
          inset 0 0 15px rgba(34,211,238,0.04);

        backdrop-filter: blur(8px);

        transition:
          transform .25s ease,
          box-shadow .25s ease;

      }

      .scada-node:hover {

        transform:
          translateY(-4px)
          scale(1.02);

        border-color:
          rgba(34,211,238,0.8);

        box-shadow:
          0 10px 30px rgba(0,0,0,0.7),
          0 0 20px rgba(34,211,238,0.2);

      }


      /* ==========================================
         TELEMETRY BOX
      ========================================== */

      .scada-telemetry-box {

        margin-top: 7px;

        padding: 6px;

        border-radius: 6px;

        background:
          linear-gradient(
            145deg,
            rgba(3,25,34,0.96),
            rgba(3,15,23,0.98)
          );

        border:
          1px solid rgba(56,189,248,0.22);

        color: #e2e8f0;

      }


      /* ==========================================
         TELEMETRY GRID
      ========================================== */

      .telemetry-grid {

        display: grid;

        grid-template-columns:
          repeat(2, 1fr);

        gap: 4px;

      }

      .telemetry-grid.three {

        grid-template-columns:
          repeat(3, 1fr);

      }


      .telemetry-grid > div {

        padding: 4px;

        border-radius: 4px;

        background:
          rgba(15,23,42,0.75);

        border:
          1px solid rgba(56,189,248,0.08);

      }


      .telemetry-grid span {

        display: block;

        font-size: 7px;

        color: #64748b;

        font-weight: 800;

        letter-spacing: .5px;

      }


      .telemetry-grid strong {

        display: block;

        margin-top: 2px;

        font-size: 10px;

        color: #67e8f9;

        font-weight: 800;

      }


      .telemetry-grid small {

        font-size: 7px;

        color: #94a3b8;

      }


      /* ==========================================
         TELEMETRY FOOTER
      ========================================== */

      .telemetry-footer {

        margin-top: 5px;

        padding-top: 4px;

        border-top:
          1px solid rgba(56,189,248,0.12);

        display: flex;

        justify-content:
          space-between;

        gap: 5px;

        font-size: 7px;

      }

      .telemetry-footer span {

        color: #64748b;

        font-weight: 800;

      }

      .telemetry-footer strong {

        color: #facc15;

        max-width: 100px;

        overflow: hidden;

        white-space: nowrap;

        text-overflow: ellipsis;

      }


      /* ==========================================
         STATUS
      ========================================== */

      .telemetry-status {

        margin-top: 5px;

        padding-top: 4px;

        border-top:
          1px solid rgba(56,189,248,0.1);

        display: flex;

        align-items: center;

        gap: 5px;

        font-size: 7px;

        font-weight: 800;

        color: #4ade80;

      }


      /* ==========================================
         PUMP
      ========================================== */

      .scada-pump {

        animation:
          pumpFloat 2s ease-in-out infinite;

      }

      @keyframes pumpFloat {

        0% {
          transform: translateY(0);
        }

        50% {
          transform: translateY(-5px);
        }

        100% {
          transform: translateY(0);
        }

      }


      .pump-ring {

        width: 65px;

        height: 65px;

        display: flex;

        align-items: center;

        justify-content: center;

        border-radius: 50%;

        background:
          radial-gradient(
            circle,
            rgba(34,211,238,0.2),
            rgba(2,15,23,0.9)
          );

        border:
          1px solid rgba(34,211,238,0.45);

        box-shadow:
          0 0 15px rgba(34,211,238,0.3);

        animation:
          pumpGlow 1.5s infinite;

      }

      @keyframes pumpGlow {

        0% {
          box-shadow:
            0 0 8px rgba(34,211,238,0.2);
        }

        50% {
          box-shadow:
            0 0 25px rgba(34,211,238,0.65);
        }

        100% {
          box-shadow:
            0 0 8px rgba(34,211,238,0.2);
        }

      }


      /* ==========================================
         LOADER
      ========================================== */

      .scada-loader {

        width: 75px;

        height: 75px;

        position: relative;

        display: flex;

        align-items: center;

        justify-content: center;

      }

      .loader-ring {

        position: absolute;

        inset: 0;

        border-radius: 50%;

        border:
          2px solid transparent;

        border-top-color:
          #22d3ee;

        border-right-color:
          #22c55e;

        animation:
          loaderSpin 1s linear infinite;

      }

      .loader-ring-2 {

        inset: 8px;

        border-top-color:
          #38bdf8;

        border-right-color:
          #06b6d4;

        animation:
          loaderSpinReverse .8s linear infinite;

      }

      .loader-core {

        color: #67e8f9;

        font-size: 10px;

        font-weight: 900;

        letter-spacing: 1px;

      }

      @keyframes loaderSpin {

        to {
          transform: rotate(360deg);
        }

      }

      @keyframes loaderSpinReverse {

        to {
          transform: rotate(-360deg);
        }

      }


      /* ==========================================
         LANE LABELS
      ========================================== */

      .scada-network .lane {

        z-index: 2;

        position: absolute;

        top: 52px;

        height: 430px;

        width: 31%;

        border-left:
          1px dashed rgba(34,211,238,0.12);

        border-right:
          1px dashed rgba(34,211,238,0.12);

        background:
          linear-gradient(
            180deg,
            rgba(34,211,238,0.025),
            transparent
          );

        color: rgba(103,232,249,0.45);

        font-size: 8px;

        font-weight: 900;

        letter-spacing: 2px;

        padding: 8px;

        box-sizing: border-box;

      }

      .scada-network .lane span {

        margin-right: 5px;

        color: #22d3ee;

      }

      .scada-network .lane-intake {

        left: 0;

      }

      .scada-network .lane-wtp {

        left: 33%;

      }

      .scada-network .lane-oht {

        left: 66%;

      }


      /* ==========================================
         MOBILE
      ========================================== */

      @media (max-width: 768px) {

        .scada-network {
          min-width: 850px !important;
        }

        .scada-node {
          width: 145px !important;
        }

      }

    `}
  </style>

</aside>

          </section>

        </div>

        {/* ===== RIGHT (20%) ===== */}
        <div
          style={{
            flex: "0 0 20%",
            maxWidth: "20%",
            minHeight: "300px",
            background: "#0f172a",
            overflowY: "auto",
          }}
        >
          {/*CODE FOR CENTER Bhupen2*/}
          <div className="assets">
            <div className='tooltitlediv linear-gradian-bg d-flex justify-content-between align-items-center px-3'>
              <h6 className='sidebarbuttontitle text-white m-0'>
                SCADA (Supervisory Control and Data Acquisition)
              </h6>

            </div>

            {/* <div className='scroll-layerdiv flex-grow-1' style={{ overflowY: 'auto' }}> */}
            <div style={{
            
              overflowY: "auto",
              borderRadius: "4px", overflow: "auto",
            }}>


              <div style={{       background: "linear-gradient(90deg, rgba(174, 203, 214, 1) 0%, rgba(221, 236, 227, 1) 50%, rgba(245, 245, 245, 1) 100%)",
         }}>
                {/* ===== CODE FOR DETAILS DATA ===== */}

                {/* ===== DIVIDER ===== */}
                <div
                  style={{
                    backgroundColor: "#066853ff",
                    color: "white",
                    height: "10px",
                  }}
                ></div>

                {/* ===== SEWERAGE TOGGLE ===== */}


                {/* BHUPEN_LIST DEVICE ===== SCADA DEVICE LIST SECTION ===== */}
                <div
                  style={{
                    height: "550px",
                 
                    color: "white",
                    
                  }}
                >
                  {/* ===== DEVICE CARDS ===== */}
                  <>
                    {/* ===================================================== */}
                    {/* HEADER */}
                    {/* ===================================================== */}

                    <div style={countBox}>
                      <div style={cardHeader}>Total WTP SCADA Installed</div>
                      <div style={countValue}>{tableData?.length || 1}</div>
                    </div>

                    {/* ===== DIVIDER ===== */}
                    <div
                      style={{
                        backgroundColor: "#066853ff",
                        color: "white",
                        height: "10px",
                      }}
                    ></div>

                    <div style={cardHeader}>List of SCADA Device</div>
                  
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        padding: "10px",

                      }}
                    >
                      {tableDataINTEK?.map((row, index) => (
                        <div
                          key={row.intakeId + index}
                         
                        onClick={() => navigate(
                          `/scada-wtp-details/${encodeURIComponent(String(row.intakeId).trim().toUpperCase())}`,
                          { state: { rowData: row } }
                        )}

                          style={{
                            width: "300px",
                            minWidth: "300px",
                            maxWidth: "300px",

                            padding: "10px",
                            borderRadius: "14px",
                            background:
                              index % 2 === 0
                                ? "linear-gradient(145deg,#0f6771,#0b737b,#07989b)"
                                : "linear-gradient(145deg,#093a36,#0f6e61,#086655)",
                            border: "1px solid rgba(255,255,255,0.12)",
                            boxShadow:
                              index % 2 === 0
                                ? "0 10px 25px rgba(7,152,155,0.35)"
                                : "0 10px 25px rgba(8,177,146,0.35)",
                            backdropFilter: "blur(10px)",
                            transition: "all 0.3s ease",
                            cursor: "pointer",
                            color: "#fff",
                            overflow: "hidden",
                            position: "relative",
                            flexShrink: 0,
                          }}
                        >
                          {/* TOP HEADER */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "10px",
                            }}
                          >
                            {/* LEFT SIDE */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              {/* LIVE DOT */}
                                {/* STATUS */}
                            <div
                              style={{
                                width: "25px",
                                height: "25px",
                                borderRadius: "50%",
                                background: "linear-gradient(135deg, #e7e74e, #77812c)",
                                color: "#1b0202",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "bold",
                                fontSize: "14px",
                                margin: "auto",
                                float: "right",
                                boxShadow: "0 3px 8px rgba(0,0,0,0.2)"
                              }}
                            >
                              {index + 1}
                            </div>

                             
                              {/* TITLE */}
                              <div>


                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#cbd5e1",
                                  }}
                                >
                                  ID : {row.intakeId}
                                  
                                </div>

                                <div
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "700",
                                    color: "#facc15",
                                    marginTop: "2px",
                                    width: "200px",
                                    overflow: "wrap",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {row.schemeName}
                                </div>
                              </div>
                            </div>                          
                          </div>

                          {/* DETAILS */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "6px",
                            }}
                          >
                            {/* Department */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                background: "rgba(255,255,255,0.05)",
                                padding: "7px 9px",
                                borderRadius: "10px",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "10px",
                                  color: "#fdfafa",
                                  fontWeight: "600",
                                }}
                              >
                                Department
                              </div>

                              <div
                                style={{
                                  fontSize: "10px",
                                  fontWeight: "700",
                                 color: "#fdfafa",
                                }}
                              >
                                {row.department_Name || "-"}
                              </div>
                            </div>

                            {/* Vendor */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                background: "rgba(74, 13, 13, 0.05)",
                                padding: "7px 9px",
                                borderRadius: "10px",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "10px",
                                  color: "#fdfafa",
                                  fontWeight: "600",
                                }}
                              >
                                Vendor
                              </div>

                              <div
                                style={{
                                  fontSize: "10px",
                                  fontWeight: "700",
                                  color: "#fdfafa",
                                  textAlign: "right",
                                  width: "100%",
                                }}
                              >
                                {row.vendor_Name || "-"}
                              </div>

                            </div>
                          </div>

                          {/* ANIMATION */}
                          <style>
                            {`
          @keyframes liveBlink {
            0% {
              opacity: 1;
              transform: scale(1);
            }

            50% {
              opacity: 0.4;
              transform: scale(1.5);
            }

            100% {
              opacity: 1;
              transform: scale(1);
            }
          }
        `}
                          </style>
                        </div>
                      ))}
                    </div>
                   
                  </>

                  {/* ===== DEVICE CARDS ===== */}


                </div>
              </div>
              {/* <button className="btn-refresh2" onClick={handleReset} style={{ marginTop: "14px" }}>
                     <img src={isTheme === 'light' ? "img/refreshlight.svg" : "img/refresh.svg"} alt="refresh" width="20px" height="20px" /> Refresh
                 </button> */}
            </div>
          </div>
        </div>

      </div>

      <div style={{ width: "250px;", backgroundColor: "lightcyan" }}>
        <div
          style={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            background: "#020617",
            overflow: "hidden",
            boxSizing: "border-box",
          }}
        >
          {/* ================= FOOTER / REPORT CONTAINER ================= */}
          <div
            className="map-footer"
            style={{
              position: tableMaximize ? "fixed" : "relative",
              inset: tableMaximize ? "0" : "auto",
              width: "100%",
              maxWidth: "100vw",
              height: tableMaximize ? "100vh" : "auto",
              maxHeight: tableMaximize ? "100vh" : "none",
              zIndex: tableMaximize ? 9999 : 1,
              background: tableMaximize
                ? "rgba(15,23,42,0.97)"
                : "transparent",
              padding: tableMaximize ? "10px" : "0",
              overflow: "hidden",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                boxSizing: "border-box",
              }}
            >
              {/* ================= MAIN DIV ================= */}
              <div
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  minWidth: 0,
                  borderRadius: "10px",
                  paddingTop: tableMaximize ? "5px" : "20px",
                  overflow: "hidden",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
                  boxSizing: "border-box",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    minWidth: 0,
                    boxSizing: "border-box",
                  }}
                >
                  {/* ================= HEADER ================= */}
                  <div
                    style={{
                      background:
                        "linear-gradient(135deg,#0f6d86,#0b5f68)",
                      borderTopLeftRadius: "10px",
                      borderTopRightRadius: "10px",
                      padding: "12px 18px",
                      color: "#fff",
                      boxShadow: "0 2px 8px rgba(0,0,0,.15)",
                      width: "100%",
                      maxWidth: "100%",
                      boxSizing: "border-box",
                    }}
                  >
                    {/* ================= HEADER TOP ROW ================= */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "12px",
                        marginBottom: "10px",
                        flexWrap: "wrap",
                        width: "100%",
                      }}
                    >
                      {/* ================= KPI CARDS ================= */}
                      <div
                        style={{
                          flex: "1 1 320px",
                          minWidth: 0,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "6px",
                          flexWrap: "wrap",
                        }}
                      >
                        {[
                          {
                            title: "Total Schemes",
                            value: RTPcards.schemes,
                            color: "#1976d2",
                          },
                          {
                            title: "Total ULB",
                            value: RTPcards.ulb,
                            color: "#2e7d32",
                          },
                          {
                            title: "Total Intake",
                            value: RTPcards.intake,
                            color: "#ef6c00",
                          },
                          {
                            title: "Total WTP",
                            value: RTPcards.wtp,
                            color: "#7b1fa2",
                          },
                          {
                            title: "Total OHT",
                            value: RTPcards.oht,
                            color: "#00897b",
                          },
                        ].map((card, index) => (
                          <div
                            key={index}
                            style={{
                              background: card.color,
                              color: "#fff",
                              flex: "1 1 85px",
                              width: "100px",
                              minWidth: "80px",
                              maxWidth: "110px",
                              height: "50px",
                              borderRadius: "6px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              boxShadow:
                                "0 2px 5px rgba(0,0,0,.2)",
                              boxSizing: "border-box",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "10px",
                                fontWeight: "600",
                                textAlign: "center",
                                lineHeight: "12px",
                              }}
                            >
                              {card.title}
                            </div>

                            <div
                              style={{
                                fontSize: "16px",
                                fontWeight: "700",
                                marginTop: "3px",
                              }}
                            >
                              {card.value}
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* ================= LOGO / TITLE ================= */}
                      <div
                        style={{
                          flex: "1 1 300px",
                          minWidth: 0,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            textAlign: "center",
                            flexWrap: "wrap",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src="img/mplogo.png"
                            alt="Logo"
                            style={{
                              width: "45px",
                              height: "45px",
                              objectFit: "contain",
                              flexShrink: 0,
                            }}
                          />

                          <div
                            style={{
                              minWidth: 0,
                            }}
                          >
                            <h6
                              style={{
                                margin: 0,
                                fontSize: "14px",
                                fontWeight: "700",
                                color: "#fff",
                                lineHeight: "18px",
                              }}
                            >
                              Directorate, Urban Administration & Development
                            </h6>

                            <h6
                              style={{
                                margin: "3px 0 0",
                                fontSize: "12px",
                                fontWeight: "500",
                                color: "#fff",
                              }}
                            >
                              Government of Madhya Pradesh
                            </h6>
                          </div>
                        </div>
                      </div>

                      {/* ================= ACTION BUTTONS ================= */}
                      <div
                        style={{
                          flex: "1 1 300px",
                          minWidth: 0,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                          flexWrap: "wrap",
                        }}
                      >
                        <button
                          type="button"
                          onClick={downloadExcel}
                          style={{
                            padding: "8px 14px",
                            border: "none",
                            borderRadius: "8px",
                            background:
                              "linear-gradient(135deg,#22c55e,#16a34a)",
                            color: "#fff",
                            fontWeight: "600",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                          }}
                        >
                          ⬇ Download
                        </button>

                        <button
                          type="button"
                          onClick={() =>
                            setTableMaximize(!tableMaximize)
                          }
                          style={{
                            padding: "8px 14px",
                            border: "none",
                            borderRadius: "8px",
                            background:
                              "linear-gradient(135deg,#2563eb,#1d4ed8)",
                            color: "#fff",
                            fontWeight: "600",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {tableMaximize
                            ? "🗗 Minimize"
                            : "🗖 Maximize"}
                        </button>

                        <button
                          type="button"
                          onClick={() => navigate("/SCADAWTPRTP")}
                          style={{
                            padding: "8px 14px",
                            border: "none",
                            borderRadius: "8px",
                            background:
                              "linear-gradient(135deg,#0f9d58,#087f3f)",
                            color: "#fff",
                            fontWeight: "600",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                          }}
                        >
                          📊 More Report
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* ================= TABLE AREA ================= */}
                  <div
                    id="pdfTable"
                    style={{
                      width: "100%",
                      maxWidth: "100%",
                      minWidth: 0,
                      boxSizing: "border-box",
                    }}
                  >
                    <div
                      className="sacda-table"
                      style={{
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: 0,
                        maxHeight: tableMaximize
                          ? "calc(100vh - 150px)"
                          : "auto",
                        overflow: "hidden",
                        boxSizing: "border-box",
                      }}
                    >
                      {/* ================= TABLE SECTION ================= */}
                      {tableVisible && (
                        <div
                          style={{
                            width: "100%",
                            maxWidth: "100%",
                            minWidth: 0,
                            background: "#fff",
                            borderBottomLeftRadius: "8px",
                            borderBottomRightRadius: "8px",
                            overflow: "hidden",
                            boxSizing: "border-box",
                          }}
                        >
                          <div
                            id="dataReports"
                            style={{
                              width: "100%",
                              maxWidth: "100%",
                              minWidth: 0,
                              overflow: "hidden",
                              boxSizing: "border-box",
                            }}
                          >
                            {/* ================= FILTER BAR ================= */}
                            <div
                              style={{
                                width: "100%",
                                background: "linear-gradient(90deg,#116d86,#0b6868)",
                                padding: "8px 10px",
                                borderRadius: "10px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                marginBottom: "12px",
                                color: "#fff",
                                boxSizing: "border-box",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-start",
                                  gap: "8px",
                                  flexWrap: "wrap",
                                  width: "100%",
                                  boxSizing: "border-box",
                                }}
                              >
                                {/* ================= DEPARTMENT ================= */}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                    flex: "0 0 auto",
                                    width: "180px",
                                    maxWidth: "100%",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "#ffd700",
                                      fontWeight: 600,
                                      fontSize: "12px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    Department:
                                  </span>

                                  <select
                                    value={departmentFilter}
                                    onChange={(e) =>
                                      setDepartmentFilter(e.target.value)
                                    }
                                    style={{
                                      width: "95px",
                                      height: "30px",
                                      padding: "4px 6px",
                                      borderRadius: "5px",
                                      border: "none",
                                      outline: "none",
                                      fontSize: "12px",
                                      cursor: "pointer",
                                      background: "#fff",
                                      color: "#1e293b",
                                      boxSizing: "border-box",
                                    }}
                                  >
                                    <option value="">All</option>
                                    <option value="MPUDC">MPUDC</option>
                                    <option value="UADD">UADD</option>
                                  </select>
                                </div>

                                {/* ================= SEARCH ================= */}
                                <div
                                  style={{
                                    position: "relative",
                                    width: "190px",
                                    maxWidth: "100%",
                                    flex: "0 0 auto",
                                  }}
                                >
                                  <input
                                    type="text"
                                    placeholder="🔍 Search..."
                                    value={searchText}
                                    onChange={(e) =>
                                      setSearchText(e.target.value)
                                    }
                                    style={{
                                      width: "190px",
                                      maxWidth: "100%",
                                      height: "30px",
                                      padding: "4px 28px 4px 9px",
                                      borderRadius: "5px",
                                      border: "none",
                                      outline: "none",
                                      fontSize: "12px",
                                      boxSizing: "border-box",
                                    }}
                                  />

                                  {searchText && (
                                    <span
                                      onClick={() => setSearchText("")}
                                      style={{
                                        position: "absolute",
                                        right: "8px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "#64748b",
                                        fontSize: "12px",
                                      }}
                                    >
                                      ✖
                                    </span>
                                  )}
                                </div>

                                {/* ================= COUNT ================= */}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    width: "150px",
                                    maxWidth: "100%",
                                    minHeight: "30px",
                                    flex: "0 0 auto",
                                  }}
                                >
                                  {(searchText || departmentFilter) && (
                                    <span
                                      style={{
                                        color: "#ffd700",
                                        fontWeight: 700,
                                        fontSize: "12px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      Total Records: {filteredData.length}
                                    </span>
                                  )}
                                </div>
                              </div>

                              {/* ================= RESPONSIVE ================= */}
                          <style>
  {`
    /* ================= DESKTOP / LARGE SCREEN ================= */
    @media (min-width: 1201px) {
      table {
        font-size: 12px !important;
      }

      th {
        font-size: 13px !important;
        padding: 9px 6px !important;
        line-height: 15px !important;
      }

      td {
        font-size: 12px !important;
        padding: 8px 6px !important;
        line-height: 17px !important;
      }
    }

    /* ================= LAPTOP ================= */
    @media (min-width: 769px) and (max-width: 1200px) {
      th {
        padding: 8px 5px !important;
        font-size: 12px !important;
        line-height: 14px !important;
      }

      td {
        padding: 7px 5px !important;
        font-size: 11px !important;
        line-height: 16px !important;
      }
    }

    /* ================= TABLET ================= */
    @media (max-width: 768px) {
      th {
        padding: 7px 4px !important;
        font-size: 11px !important;
        line-height: 13px !important;
      }

      td {
        padding: 7px 4px !important;
        font-size: 10px !important;
        line-height: 14px !important;
      }
    }

    /* ================= SMALL MOBILE ================= */
    @media (max-width: 480px) {
      th {
        padding: 6px 3px !important;
        font-size: 10px !important;
        line-height: 12px !important;
      }

      td {
        padding: 6px 3px !important;
        font-size: 9px !important;
        line-height: 12px !important;
      }
    }

    /* ================= ROW HOVER ================= */
    tbody tr {
      transition: background-color 0.15s ease;
    }

    tbody tr:hover {
      background-color: #dff6f4 !important;
    }
  `}
</style>
                            </div>


                            {/* ================= Bottom  Table   ================= */}
                          {/* ================= BOTTOM TABLE ================= */}
<div
  style={{
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    overflowX: "auto",
    overflowY: "auto",
    maxHeight: tableMaximize
      ? "calc(100vh - 180px)"
      : "600px",
    border: "1px solid #cbd5e1",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    WebkitOverflowScrolling: "touch",
    boxSizing: "border-box",
  }}
>
  <table
    style={{
      width: "100%",
      minWidth: "1250px",
      borderCollapse: "collapse",
      borderSpacing: 0,
      tableLayout: "fixed",
      fontFamily: "Arial, Helvetica, sans-serif",
      fontSize: "12px",
    }}
  >
    {/* ================= COLUMN WIDTHS ================= */}
    <colgroup>
      <col style={{ width: "3%" }} />
      <col style={{ width: "6%" }} />
      <col style={{ width: "8%" }} />
      <col style={{ width: "7%" }} />
      <col style={{ width: "9%" }} />
      <col style={{ width: "6%" }} />
      <col style={{ width: "6%" }} />
      <col style={{ width: "8%" }} />
      <col style={{ width: "4%" }} />
      <col style={{ width: "6%" }} />
      <col style={{ width: "6%" }} />
      <col style={{ width: "6%" }} />
      <col style={{ width: "7%" }} />
      <col style={{ width: "4%" }} />
      <col style={{ width: "6%" }} />
      <col style={{ width: "8%" }} />
    </colgroup>

    {/* ================= TABLE HEADER ================= */}
    <thead>
      <tr>
        {[
          "S.No",
          "Intake ID",
          "Department Name",
          "ULB Name",
          "SCHEME Name",
          "Intake Level (M)",
          "Intake Flow (MLD)",
          "WTP Name",
          "pH",
          "Chlorine (ppm)",
          "Turbidity (NTU)",
          "WTP In Flow (MLD)",
          "WTP Out Flow (MLD)",
          "OHT Count",
          "OHT In Flow (MLD)",
          "Last Data",
        ].map((header, index) => (
          <th
            key={index}
            style={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              padding: "9px 6px",
              backgroundColor: "#0b6868",
              color: "#ffffff",
              borderRight:
                index === 15
                  ? "none"
                  : "1px solid #0f7c7c",
              borderBottom: "2px solid #075454",
              textAlign: "center",
              verticalAlign: "middle",
              fontWeight: "700",
              fontSize: "13px",
              lineHeight: "15px",
              whiteSpace: "normal",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              boxSizing: "border-box",
            }}
          >
            {header}
          </th>
        ))}
      </tr>
    </thead>

    {/* ================= TABLE BODY ================= */}
    <tbody>
      {filteredData && filteredData.length > 0 ? (
        filteredData.map((item, index) => {
          const intakeDate = item.intakeDateTime
            ? new Date(item.intakeDateTime)
            : null;

          const today = new Date();

          const isToday =
            intakeDate &&
            intakeDate.getDate() === today.getDate() &&
            intakeDate.getMonth() === today.getMonth() &&
            intakeDate.getFullYear() === today.getFullYear();

          /* ================= ROW STYLE ================= */
          const rowStyle = {
            backgroundColor:
              index % 2 === 0
                ? "#f8fafc"
                : "#e8f1f2",
            color: "#043e47",
          };

          /* ================= CELL STYLE ================= */
          const cellStyle = {
            padding: "8px 6px",
            borderRight: "1px solid #d5dee2",
            borderBottom: "1px solid #d5dee2",
            textAlign: "center",
            verticalAlign: "middle",
            fontSize: "12px",
            fontWeight: "500",
            lineHeight: "17px",
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "break-word",
            boxSizing: "border-box",
          };

          return (
            <tr
              key={`${item.intakeId || "intake"}-${index}`}
              style={rowStyle}
            >
              {/* ================= S.NO ================= */}
              <td
                style={{
                  ...cellStyle,
                  fontWeight: "700",
                  whiteSpace: "nowrap",
                }}
              >
                {index + 1}
              </td>

              {/* ================= INTAKE ID ================= */}
              <td
                style={{
                  ...cellStyle,
                  fontWeight: "600",
                  color: "#075e68",
                  whiteSpace: "nowrap",
                }}
              >
                {item.intakeId ?? "-"}
              </td>

              {/* ================= DEPARTMENT ================= */}
              <td style={cellStyle}>
                {item.department_Name ?? "-"}
              </td>

              {/* ================= ULB ================= */}
              <td style={cellStyle}>
                {item.ulbName ?? "-"}
              </td>

              {/* ================= INTAKE / WATER WELL NAME ================= */}
              <td
                style={{
                  ...cellStyle,
                  fontWeight: "600",
                }}
              >
                {item.schemeName ?? "-"}
              </td>

              {/* ================= INTAKE LEVEL ================= */}
              <td
                style={{
                  ...cellStyle,
                  textAlign: "right",
                  whiteSpace: "nowrap",
                }}
              >
                {item.intakeLevel != null
                  ? Number(item.intakeLevel).toFixed(2)
                  : "-"}
              </td>

              {/* ================= INTAKE FLOW ================= */}
              <td
                style={{
                  ...cellStyle,
                  textAlign: "right",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                }}
              >
                {item.intakeOutletFlow != null
                  ? Number(item.intakeOutletFlow).toFixed(2)
                  : "0.00"}
              </td>

              {/* ================= WTP NAME ================= */}
              <td
                style={{
                  ...cellStyle,
                  fontWeight: "600",
                }}
              >
                {item.wtpName ?? "-"}
              </td>

              {/* ================= PH ================= */}
              <td
                style={{
                  ...cellStyle,
                  textAlign: "right",
                  whiteSpace: "nowrap",
                  fontWeight: "600",
                }}
              >
                {item.treatedPh != null
                  ? Number(item.treatedPh).toFixed(2)
                  : "-"}
              </td>

              {/* ================= CHLORINE ================= */}
              <td
                style={{
                  ...cellStyle,
                  textAlign: "right",
                  whiteSpace: "nowrap",
                  fontWeight: "600",
                }}
              >
                {item.chlorine != null
                  ? Number(item.chlorine).toFixed(2)
                  : "-"}
              </td>

              {/* ================= TURBIDITY ================= */}
              <td
                style={{
                  ...cellStyle,
                  textAlign: "right",
                  whiteSpace: "nowrap",
                  fontWeight: "600",
                }}
              >
                {item.treatedTurbidity != null
                  ? Number(item.treatedTurbidity).toFixed(2)
                  : "-"}
              </td>

              {/* ================= WTP IN FLOW ================= */}
              <td
                style={{
                  ...cellStyle,
                  textAlign: "right",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                }}
              >
                {item.wtpInletFlow != null
                  ? Number(item.wtpInletFlow).toFixed(2)
                  : "0.00"}
              </td>

              {/* ================= WTP OUT FLOW ================= */}
              <td
                style={{
                  ...cellStyle,
                  textAlign: "right",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                }}
              >
                {item.wtpOutletFlow != null
                  ? Number(item.wtpOutletFlow).toFixed(2)
                  : "0.00"}
              </td>

              {/* ================= OHT COUNT ================= */}
              <td
                style={{
                  ...cellStyle,
                  fontWeight: "700",
                  whiteSpace: "nowrap",
                }}
              >
                {item.ohtCount ?? 0}
              </td>

              {/* ================= OHT FLOW ================= */}
              <td
                style={{
                  ...cellStyle,
                  textAlign: "right",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                }}
              >
                {item.ohtTotalFlow != null
                  ? Number(item.ohtTotalFlow).toFixed(2)
                  : "0.00"}
              </td>

              {/* ================= LAST DATA ================= */}
              <td
                style={{
                  ...cellStyle,
                  fontWeight: "700",
                  color: isToday
                    ? "#15803d"
                    : "#ef1d1d",
                }}
              >
                {intakeDate ? (
                  <>
                    {/* DATE TIME */}
                    <div
                      style={{
                        fontSize: "11px",
                        fontWeight: "600",
                        lineHeight: "14px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {intakeDate.toLocaleString(
                        "en-IN",
                        {
                          day: "2-digit",
                          month: "2-digit",
                          year: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                        }
                      )}
                    </div>

                    {/* ONLINE / OFFLINE */}
                    <div
                      style={{
                        marginTop: "3px",
                        fontSize: "10px",
                        fontWeight: "800",
                        lineHeight: "12px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {isToday
                        ? "● ONLINE"
                        : "● OFFLINE"}
                    </div>
                  </>
                ) : (
                  <span
                    style={{
                      fontSize: "10px",
                      fontWeight: "800",
                      whiteSpace: "nowrap",
                    }}
                  >
                    ● OFFLINE
                  </span>
                )}
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td
            colSpan={16}
            style={{
              padding: "30px 15px",
              textAlign: "center",
              color: "#64748b",
              backgroundColor: "#ffffff",
              fontSize: "13px",
              fontWeight: "600",
            }}
          >
            No intake data found
          </td>
        </tr>
      )}
    </tbody>
  </table>

  {/* ================= RESPONSIVE TABLE CSS ================= */}
  <style>
    {`
      /* ============================================
         LARGE DESKTOP
         ============================================ */
      @media (min-width: 1401px) {
        table {
          font-size: 12px !important;
        }

        th {
          font-size: 13px !important;
          padding: 9px 6px !important;
          line-height: 15px !important;
        }

        td {
          font-size: 12px !important;
          padding: 8px 6px !important;
          line-height: 17px !important;
        }
      }

      /* ============================================
         DESKTOP
         ============================================ */
      @media (min-width: 1201px) and (max-width: 1400px) {
        table {
          font-size: 12px !important;
        }

        th {
          font-size: 12px !important;
          padding: 8px 5px !important;
          line-height: 14px !important;
        }

        td {
          font-size: 11px !important;
          padding: 7px 5px !important;
          line-height: 16px !important;
        }
      }

      /* ============================================
         LAPTOP / TABLET
         ============================================ */
      @media (min-width: 769px) and (max-width: 1200px) {
        th {
          padding: 8px 4px !important;
          font-size: 11px !important;
          line-height: 13px !important;
        }

        td {
          padding: 7px 4px !important;
          font-size: 11px !important;
          line-height: 15px !important;
        }
      }

      /* ============================================
         MOBILE
         ============================================ */
      @media (max-width: 768px) {
        th {
          padding: 7px 3px !important;
          font-size: 10px !important;
          line-height: 12px !important;
        }

        td {
          padding: 6px 3px !important;
          font-size: 10px !important;
          line-height: 13px !important;
        }
      }

      /* ============================================
         SMALL MOBILE
         ============================================ */
      @media (max-width: 480px) {
        th {
          padding: 6px 2px !important;
          font-size: 9px !important;
          line-height: 11px !important;
        }

        td {
          padding: 5px 2px !important;
          font-size: 9px !important;
          line-height: 11px !important;
        }
      }

      /* ============================================
         TABLE ROW HOVER
         ============================================ */
      tbody tr {
        transition:
          background-color 0.15s ease,
          box-shadow 0.15s ease;
      }

      tbody tr:hover {
        background-color: #dff6f4 !important;
        box-shadow: inset 3px 0 0 #0b6868;
      }

      /* ============================================
         STICKY HEADER SCROLL SHADOW
         ============================================ */
      thead th {
        box-shadow: 0 2px 3px rgba(0, 0, 0, 0.12);
      }

      /* ============================================
         BETTER NUMBER ALIGNMENT
         ============================================ */
      td {
        font-variant-numeric: tabular-nums;
      }
    `}
  </style>
</div>
                            {/* ================= Bottom Table    ================= */}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ================= RESPONSIVE CSS ================= */}
          <style>
            {`
      * {
        box-sizing: border-box;
      }

      html,
      body,
      #root {
        max-width: 100%;
        overflow-x: hidden;
      }

      .map-footer {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
      }

      .sacda-table {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
      }

      #dataReports {
        width: 100%;
        max-width: 100%;
        min-width: 0;
        box-sizing: border-box;
      }

      /* ================= TABLET ================= */
      @media (max-width: 992px) {
        .map-footer {
          padding: 5px !important;
        }

        .map-footer button {
          font-size: 12px !important;
          padding: 7px 10px !important;
        }

        .map-footer h6 {
          font-size: 12px !important;
        }
      }

      /* ================= MOBILE ================= */
      @media (max-width: 768px) {
        .map-footer {
          padding: 4px !important;
        }

        .map-footer button {
          font-size: 11px !important;
          padding: 6px 9px !important;
        }

        .map-footer img {
          width: 35px !important;
          height: 35px !important;
        }

        .map-footer h6 {
          font-size: 11px !important;
          line-height: 15px !important;
        }

        #dataReports {
          width: 100% !important;
          max-width: 100% !important;
          overflow: hidden !important;
        }

        .sacda-table {
          width: 100% !important;
          max-width: 100% !important;
        }
      }

      /* ================= SMALL MOBILE ================= */
      @media (max-width: 480px) {
        .map-footer {
          padding: 2px !important;
        }

        .map-footer button {
          flex: 1 1 auto;
          min-width: 90px;
          font-size: 10px !important;
          padding: 6px 7px !important;
        }

        .map-footer img {
          width: 32px !important;
          height: 32px !important;
        }

        .map-footer h6 {
          font-size: 10px !important;
        }
      }

      /* ================= TOUCH SCROLL ================= */
      .map-footer table {
        -webkit-overflow-scrolling: touch;
      }
    `}
          </style>
        </div>

      </div>


      {/*CODE FOR POPUP*/}

      {/*CODE FOR POPUP*/}

      {showPopup && (
        <>
          {/* OVERLAY */}
          <div
            onClick={() => setShowPopup(false)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 99998
            }}
          />

          {/* MODAL */}
          <div
            style={{
              position: "fixed",
              bottom: "20%",
              left: "50%",
              transform: "translateX(-50%)",
              width: "1000px",
              height: "600px",
              background: "#fff",
              borderRadius: "10px",
              zIndex: 99999,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden"
            }}
          >
            {/* HEADER */}


            <div
              style={{
                position: "relative",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "8px 0",
              }}
            >
              {/* CENTER TOTAL */}
              <b>
                Total: {tableDataINTEK.length}
              </b>

              {/* RIGHT SIDE BUTTONS */}
              <div
                style={{
                  position: "absolute",
                  right: "0",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <button
                  onClick={downloadSearchExcel}
                  style={{
                    borderRadius: "4px",
                    border: "none",
                    backgroundColor: "#054f71",
                    color: "#fff",
                    padding: "6px 12px",
                    cursor: "pointer",
                  }}
                >
                  Download Excel
                </button>

                <button
                  onClick={() => setShowPopup(false)}
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "4px",
                    border: "none",
                    backgroundColor: "#dc3545",
                    color: "#fff",
                    fontSize: "18px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  ×
                </button>
              </div>
            </div>
            {/* TABLE */}
            <div style={{ flex: 1, overflow: "auto", padding: "10px" }}>
              <table className="custom-table">
                <thead>
                  <tr>
                    <th>S.NO</th>
                    <th>Town / District</th>

                    {/* Dynamic Headers */}
                    {tableDataINTEK.length > 0 &&
                      Object.keys(tableDataINTEK[0])
                        .filter(
                          (key) => key !== "ulbName" && key !== "districtName"
                        )
                        .map((key) => (
                          <th key={key}>{key}</th>
                        ))}
                  </tr>
                </thead>

                <tbody>
                  {tableDataINTEK.length > 0 ? (
                    tableDataINTEK.map((item, index) => (
                      <tr key={index}>
                        {/* S.NO */}
                        <td>{index + 1}</td>

                        {/* LOCATION */}
                        <td>
                          {item.ulbName}, {item.districtName}
                        </td>

                        {/* Dynamic Values */}
                        {Object.keys(item)
                          .filter(
                            (key) => key !== "ulbName" && key !== "districtName"
                          )
                          .map((key, i) => (
                            <td key={i}>
                              {key === "recordDateTime"
                                ? new Date(item[key]).toLocaleString()
                                : item[key] ?? "-"}
                            </td>
                          ))}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="100%">No results found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}



      {/* CODE FOR*/}




      {/* CODE FOR*/}




    </div>
  );

}
